export const enum CompositionType {
  USED_IN = "used-in",
}
